import { useNewsControllerDeleteNewsMutation } from '@api/admin/adminGeneratedApi';
import { useNotifications } from '@area/notifications/hooks/useNotifications';
import { useEffect, useState } from 'react';

export const useDeletePublication = (cb: () => void) => {
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);
  const [deletingRowId, setDeletingRowId] = useState<string | null>(null);
  const [loadingRowId, setloadingRowId] = useState<string>();
  const { handlePushItem } = useNotifications();
  const [deletePublication, { isSuccess, status }] = useNewsControllerDeleteNewsMutation();

  const openDeleteConfirmationModal = (id: string) => {
    setDeletingRowId(id);
    setDeleteConfirmationModalOpen(true);
  };

  const closeDeleteConfirmationModal = () => {
    setDeletingRowId(null);
    setDeleteConfirmationModalOpen(false);
  };

  const confirmDelete = () => {
    deletePublication({ id: deletingRowId! });
    setloadingRowId(deletingRowId!);
    closeDeleteConfirmationModal();
  };

  useEffect(() => {
    if (isSuccess && status === 'fulfilled') {
      handlePushItem({ severity: 'success', text: 'Публикация успешно удалена' });
      cb();
    }
  }, [isSuccess, status]);

  return {
    deleteConfirmationModalOpen,
    openDeleteConfirmationModal,
    closeDeleteConfirmationModal,
    confirmDelete,
    loadingRowId,
  };
};
